import { HttpErrorResponse } from '@angular/common/http';

import type {
  AnyIntelligenceSettings,
  IntelligenceFeatureSettings,
  DisqualifyReasonOption,
} from '@core/intelligence-types';
import {
  createSingleEntityStore,
  getSingleEntityActions,
  ngrxEvent,
  PickActions,
} from '@core/ngrx-legacy';

const {
  actions,
  reducer: IntelligenceSettingsReducer,
  selectors: IntelligenceSettingsSelectors,
  namespace: IntelligenceSettingsNamespace,
} = createSingleEntityStore<AnyIntelligenceSettings[]>()('IntelligenceSettingsState', {
  customActions: adapter => {
    const defaultActions = getSingleEntityActions(adapter);
    return {
      toggleFeature: (state, payload: Partial<Record<AnyIntelligenceSettings['field'], boolean>>) =>
        adapter.markAsPending(state),
      toggleFeatureSuccess: (state, payload: AnyIntelligenceSettings[]) =>
        defaultActions.fetchSuccess(state, payload),
      toggleFeatureFailed: (state, payload: HttpErrorResponse) =>
        defaultActions.fetchFailed(state, payload),
      updateFeatureSettings: (state, payload: Partial<IntelligenceFeatureSettings>) =>
        adapter.markAsPending(state),
      updateFeatureSettingsSuccess: (state, payload: AnyIntelligenceSettings[]) =>
        defaultActions.fetchSuccess(state, payload),
      updateFeatureSettingsFailed: (state, payload: HttpErrorResponse) =>
        defaultActions.fetchFailed(state, payload),
      fetchDisqualifyReasons: ngrxEvent<{ appGuid: string }>(),
      fetchDisqualifyReasonsSuccess: ngrxEvent<DisqualifyReasonOption[]>(),
      fetchDisqualifyReasonsFailed: ngrxEvent<HttpErrorResponse>(),
    };
  },
});

const IntelligenceSettingsActions: PickActions<
  typeof actions,
  'toggleFeature' | 'updateFeatureSettings' | 'fetchDisqualifyReasons' | 'fetch'
> = actions;

export {
  IntelligenceSettingsActions,
  IntelligenceSettingsReducer,
  IntelligenceSettingsSelectors,
  IntelligenceSettingsNamespace,
};
